module.exports = __webpack_public_path__ + "img/carrousel-arco-digi-1.99921b7f.png";